import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Use localStorage for web
import app from "./reducers/app";
import { composeWithDevTools } from "@redux-devtools/extension";
import constant from "./resources/constant";

// Create persist config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["app"],
};
const rootReducer = combineReducers({
  app,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = createStore(
//   rootReducer,
//   constant.ENVIRONMENT === constant.env.PRODUCTION
//     ? applyMiddleware(thunk)
//     : composeWithDevTools(applyMiddleware(thunk))
// );

const store = createStore(persistedReducer, applyMiddleware(thunk));

export const persistor = persistStore(store);

export default store;
